import { render, staticRenderFns } from "./RomaConfirmDialog.vue?vue&type=template&id=37e989d5"
import script from "./RomaConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./RomaConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./RomaConfirmDialog.vue?vue&type=style&index=0&id=37e989d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports